import React, { useContext, useEffect, useMemo } from "react";
import { Column } from "react-table";
// Hooks
import { useAnimalsSpeciesActive } from "hooks";
// Utils
import { TableOptionsContext } from "config/tableOptionsProvider";
import { TABLE_IDS } from "constants/Interface";
// Types
import { GetAnimalsList_animalsExtended_animals } from "api/MyLivestock/Animal/types/GetAnimalsList";
// Components
import { Table } from "components";

interface SelectedAnimalsTableProps {
  columns: Column<GetAnimalsList_animalsExtended_animals>[];
  hiddenColumns?: string[];
  sourceTableId: string;
}

export const SelectedAnimalsTable: React.FC<SelectedAnimalsTableProps> = ({
  columns,
  hiddenColumns,
  sourceTableId,
}) => {
  const tableId = TABLE_IDS.ANIMALS_SELECTED;

  const { unfilteredAnimals } = useAnimalsSpeciesActive();
  const { getTableOptions, setTableOptions } = useContext(TableOptionsContext);

  const sourceTableOptions = getTableOptions(sourceTableId);
  const { selectedRowsIds: sourceSelectedIds } = { ...sourceTableOptions };

  const selectedAnimals = useMemo(() => {
    const animalIds = sourceSelectedIds ? [...sourceSelectedIds] : [];

    return unfilteredAnimals.filter((animal) =>
      animalIds.includes(animal?.id),
    ) as GetAnimalsList_animalsExtended_animals[];
  }, [unfilteredAnimals, sourceSelectedIds]);

  useEffect(() => {
    setTableOptions({
      id: tableId,
      selectedRows: selectedAnimals,
      selectedRowsIds: sourceSelectedIds,
    });
  }, [selectedAnimals, sourceSelectedIds]);

  return (
    <Table<GetAnimalsList_animalsExtended_animals>
      columns={columns}
      data={selectedAnimals}
      hiddenColumns={hiddenColumns}
      pagination
      initialPageSize={50}
      isAnimals
      tableId={tableId}
    />
  );
};
